
import { defineComponent } from 'vue';
import EstateAgentReviewStars from './EstateAgentReviewStars.vue';
import AdListGallery from '@/ad/components/AdListGallery.vue';

export default defineComponent({
  components: {
    EstateAgentReviewStars,
    AdListGallery,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  computed: {
    address(): string {
      let address = '';
      address += this.formatAddressPart(address, '', this.review.street);
      address += this.formatAddressPart(address, ' ', this.review.streetNumber);
      address += this.formatAddressPart(address, ', ', this.review.city);
      return address;
    },
  },
  methods: {
    formatAddressPart(address: string, concatString: string, part: string) {
      if (!address) {
        concatString = '';
      }
      return part ? concatString + part : '';
    },
  },
});
